import bootstrap from './bootstrap';
bootstrap.init();

// Require Vue
import Vue from 'vue'

// Register Vue Components
import vuetify from './vuetify_installer/vuetify_installer'
import Main from "./components/main/Main.vue";
import router from './router/router.js';
import auth from './auth/auth.js';
import store from './store/store.js';
import moment from 'moment';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import L from 'leaflet';
import * as Sentry from "@sentry/vue";
delete L.Icon.Default.prototype._getIconUrl;
import icon from 'leaflet/dist/images/marker-icon.png';
import icon2x from 'leaflet/dist/images/marker-icon-2x.png';
import shadow from 'leaflet/dist/images/marker-shadow.png';

L.Icon.Default.mergeOptions({
   iconRetinaUrl: icon2x,
   iconUrl: icon,
   shadowUrl: shadow,
});

// Initialize Vue
const app = new Vue({
  el: '#app',
  vuetify,
  auth,
  router,
  store,

  components: {
      "main-component": Main
  },
  mounted() {
      if (auth.check()) {
          this.$store.dispatch('getRoles', this);
          this.$store.dispatch('getProvincias', this);
          store.dispatch('getMetodosPago', this);
          this.$store.dispatch('getFormacionesExpired', this);
          this.$store.dispatch('getCanales', this);
          this.$store.dispatch('getFamilias', this);
          this.$store.dispatch('getMaxPrecioProducto', this);
        }
      },
});

Sentry.init({
    app,
    dsn: "https://7b056c3fcd5b1edd4cfd8ee6807f4d09@o4508040967487488.ingest.de.sentry.io/4508041215869008",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

